module.exports = __webpack_public_path__ + "static/img/xms.27053a8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/xms.png
// module id = OZqY
// module chunks = 0